import React from "react";
import html2pdf from "html2pdf.js/dist/html2pdf.min";
import ReactDOMServer from "react-dom/server";
import GodImage from "../../asset/images/pdf-img.png";
import axios from "axios";
import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { Notify } from "notiflix";

function PdfBiodata({ Value, showPhoto = true }) {
    if (!Value) {
        return "loading..."
    }
    const AmsamChart = Value.amsam_chart;
    const RasiChart = Value.rasi_chart;
    const PersonalInfo = Value.profile_data;
    const register_date = Value.profile_data.register_date;
    const dateObj = new Date(register_date);

    const day = String(dateObj.getDate()).padStart(2, "0");
    const month = String(dateObj.getMonth() + 1).padStart(2, "0");
    const year = dateObj.getFullYear();

    const formattedRegisterData = `${day}-${month}-${year}`;


    if (!PersonalInfo) {
        return <p>Loading..</p>;
    }
    const AmsamChartAlignment = (data) => {
        var alignment = data.split(" ");
        return alignment.map((value, key) =>
            key % 2 !== 0 ? (
                <span key={key}> {value} </span>
            ) : key === 0 ? (
                <span key={key}> {value} </span>
            ) : (
                <>
                    <br />
                    <span key={key}>{value}</span>
                </>
            )
        );
    };
    const RasiChartAlignment = (data) => {
        console.log(data);
        var alignment = data.split(",");
        return alignment.map((value, key) =>
            key % 2 !== 0 ? (
                <span key={key}> {value} </span>
            ) : key === 0 ? (
                <span key={key}> {value} </span>
            ) : (
                <>
                    <br />
                    <span key={key}>{value}</span>
                </>
            )
        );
    };
    const getAge = (dob) => {
        console.log(dob);
        const [day, month, year] = dob.split("-").map(Number);
        const birthDate = new Date(year, month - 1, day);
        const today = new Date();

        let age = today.getFullYear() - birthDate.getFullYear();
        if (
            today.getMonth() < birthDate.getMonth() ||
            (today.getMonth() === birthDate.getMonth() && today.getDate() < birthDate.getDate())
        ) {
            age--;
        }

        return age;
    };


    const style = {
        border: {
            borderTop: "2px solid #793508 !important",
        },
        sheet: {
            width: "21cm",
            minHeight: "29.1cm",
            margin: "10px auto",
            borderRadius: "5px",
            //   background: "#fff",
            boxShadow: "0 0 5px rgba(0, 0, 0, 0.1)",
            border: "5px solid #793508",
            //   backgroundColor: "#FDE3D6",
            color: "brown",
            borderStyle: "double",
        },

        "@page": {
            size: "A4",
            margin: 0,
        },
        "@media print": {
            sheet: {
                margin: 0,
                border: "initial",
                borderRadius: "initial",
                width: "initial",
                minHeight: "initial",
                boxShadow: "initial",
                pageBreakAfter: "always",
            },
        },
        sheetPrint: {
            height: "1090px",
            border: "5px solid #793508",
            backgroundColor: "#FDE3D6",
            color: "#793508",
            borderStyle: "double",
            margin: "5mm",
        },
        qus: {
            fontSize: "12.5px",
            fontWeight: "bold",
        },
        ans: {
            fontSize: "11.5px",
            fontWeight: "bold",
        },
        birthTable: {
            width: "100%",
            background: "#fff",
            fontSize: "12px",
            marginBottom: "1px",
            border: "1px solid #793508",
            position: "relative",
        },
        laknamAfter: {
            content: "''",
            width: "23px",
            border: "1px solid #793508",
            position: "absolute",
            top: "7px",
            left: "-4px",
            transform: "rotate(136deg)",
        },
        laknamBefore: {
            content: "''",
            width: "35px",
            border: "1px solid #793508",
            position: "absolute",
            top: "11px",
            left: "-6px",
            transform: "rotate(136deg)",
        },
        rasiChart: {
            textAlign: "center",
            fontSize: "12px",
            fontWeight: "600",
            color: "#793508",
        },
        rasiBirth: {
            border: "1px solid #793508    ",
            width: "70px",
            height: "80px",
            paddingLeft: "12px",
            position: "relative",
            //   paddingLeft: "15px"
        },
    };

    return (
        <>
            <div id="bio-modal m-0">
                <section className=" m-auto" id="" style={style.sheet}>
                    <div className="container-fluid" id="page1">
                        <div className="head text-center d-flex">
                            <img
                                src={GodImage}
                                className="img-fluid"
                                alt="Pdf Photo"
                                height={80}
                                width={80}
                            />
                            <p
                                className=" p-0 text-danger fw-bold mb-0"
                                style={{ fontSize: "14px" }}
                            >
                                <span style={{ fontSize: '20px' }}>கோவை கொங்குநாடு மேட்ரிமோனி</span>
                                <br />
                                <span className="text-success mb-0">
                                    www.kovaikongunadumatrimony.com
                                </span>
                                <br></br>
                                <span className="text-danger mb-0">
                                    {" "}
                                    46, மாளவியா வீதி, SNV திருமண மண்டபம் அருகில், ராம்நகர், கோவை -
                                    641009.
                                </span>
                                <br></br>
                                <span>மொபைல்:+91 9952676737, 04224513426</span>
                            </p>

                            <br></br>
                            <p></p>
                            <hr />
                            <p className="m-0 p-0"></p>
                        </div>

                        <div className="row">

                            <div className="col-6">
                                <p className="mb-2" >பதிவு தேதி:<span className="text-success fw-bold"> {formattedRegisterData}</span> </p>
                            </div>
                            <div className="col-6 text-end" >
                                <p>பதிவு எண்  :  <span className="text-success fw-bold">{PersonalInfo.profile_id}</span></p>
                            </div>
                        </div>
                        <hr className="mt-0" />
                        <div className="row">
                            <div className="col-12 text-center m-0 p-0"></div>
                            <div className="col-7 pb-0">
                                <div className="row">

                                    <div className="col-5 qus" style={style.qus}>
                                        பெயர் <span className="float-end">:</span>
                                    </div>
                                    <div className="col-7 p-0" style={style.ans}>
                                        {PersonalInfo.name}
                                    </div>

                                    <div className="col-5 qus" style={style.qus}>
                                        பாலினம் <span className="float-end">:</span>
                                    </div>
                                    <div className="col-7 p-0" style={style.ans}>
                                        {PersonalInfo.gender}
                                    </div>
                                    <div className="col-5 qus" style={style.qus}>
                                        திருமண நிலை <span className="float-end">:</span>
                                    </div>
                                    <div className="col-7 p-0" style={style.ans}>
                                        {PersonalInfo.martial_status}
                                    </div>
                                    <div className="col-5 qus" style={style.qus}>
                                        ஜாதகம் <span className="float-end">:</span>
                                    </div>
                                    <div className="col-7 p-0" style={style.ans}>
                                        {PersonalInfo.jathagam}
                                    </div>
                                    <div className="col-5 qus" style={style.qus}>
                                        பிறந்த தேதி <span className="float-end">:</span>
                                    </div>
                                    <div className="col-7 p-0" style={style.ans}>
                                        {PersonalInfo.birth_date} {PersonalInfo.kilamai ? `- ${PersonalInfo.kilamai}` : ""}

                                    </div>
                                    <div className="col-5 qus" style={style.qus}>
                                        பிறந்த நேரம் <span className="float-end">:</span>
                                    </div>
                                    <div className="col-7 p-0" style={style.ans}>
                                        {PersonalInfo.birth_time}
                                    </div>
                                    <div className="col-5 qus" style={style.qus}>
                                        வயது <span className="float-end">:</span>
                                    </div>
                                    <div className="col-7 p-0" style={style.ans}>
                                        {PersonalInfo && getAge(PersonalInfo.birth_date)}
                                    </div>
                                    <div className="col-5 qus" style={style.qus}>
                                        பிறந்த ஊர் <span className="float-end">:</span>
                                    </div>
                                    <div className="col-7 p-0" style={style.ans}>
                                        {PersonalInfo.birth_place}
                                    </div>
                                    <div className="col-5 qus" style={style.qus}>
                                        இருப்பிடம் <span className="float-end">:</span>
                                    </div>
                                    <div className="col-7 p-0" style={style.ans}>
                                        {PersonalInfo.living_place}
                                    </div>
                                    <div className="col-5 qus" style={style.qus}>
                                        படிப்பு <span className="float-end">:</span>
                                    </div>
                                    <div className="col-7 p-0" style={style.ans}>
                                        {PersonalInfo.education}
                                    </div>

                                    <div className="col-5 qus" style={style.qus}>
                                        பணி விவரம் <span className="float-end">:</span>
                                    </div>
                                    <div className="col-7 p-0" style={style.ans}>
                                        {PersonalInfo.job_description}
                                    </div>
                                    <div className="col-5 qus" style={style.qus}>
                                        பணி இடம் <span className="float-end">:</span>
                                    </div>
                                    <div className="col-7 p-0" style={style.ans}>
                                        {PersonalInfo.work_place}
                                    </div>

                                    <div className="col-5 qus" style={style.qus}>
                                        மாத வருமானம் <span className="float-end">:</span>
                                    </div>
                                    <div className="col-7 p-0" style={style.ans}>
                                        {PersonalInfo.monthly_income}
                                    </div>
                                    <div className="col-5 qus" style={style.qus}>
                                        இரத்த வகை <span className="float-end">:</span>
                                    </div>
                                    <div className="col-7 p-0" style={style.ans}>
                                        {PersonalInfo.blood_group}
                                    </div>
                                    <div className="col-5 qus" style={style.qus}>
                                        ஜாதி <span className="float-end">:</span>
                                    </div>
                                    <div className="col-7 p-0" style={style.ans}>
                                        {PersonalInfo.caste}
                                    </div>
                                    <div className="col-5 qus" style={style.qus}>
                                        குலம்/கோத்ரம் <span className="float-end">:</span>
                                    </div>
                                    <div className="col-7 p-0" style={style.ans}>
                                        {PersonalInfo.kulam}
                                    </div>
                                    <div className="col-5 qus" style={style.qus}>
                                        குலதெய்வம்  <span className="float-end">:</span>
                                    </div>
                                    <div className="col-7 p-0" style={style.ans}>
                                        {PersonalInfo.kula_deivam}
                                    </div>
                                    <div className="col-5 qus" style={style.qus}>
                                        நிறம் <span className="float-end">:</span>
                                    </div>
                                    <div className="col-7 p-0" style={style.ans}>
                                        {PersonalInfo.color}
                                    </div>
                                    <div className="col-5 qus" style={style.qus}>
                                        உயரம் <span className="float-end">:</span>
                                    </div>
                                    <div className="col-7 p-0" style={style.ans}>
                                        {PersonalInfo.height}
                                    </div>
                                    <div className="col-5 qus" style={style.qus}>
                                        எடை <span className="float-end">:</span>
                                    </div>
                                    <div className="col-7 p-0" style={style.ans}>
                                        {PersonalInfo.weight}
                                    </div>
                                    <div className="col-5 qus" style={style.qus}>
                                        நட்சத்திரம் <span className="float-end">:</span>
                                    </div>
                                    <div className="col-7 p-0" style={style.ans}>
                                        {PersonalInfo.star}
                                    </div>

                                    <div className="col-5 qus" style={style.qus}>
                                        ராசி <span className="float-end">:</span>
                                    </div>
                                    <div className="col-7 p-0" style={style.ans}>
                                        {PersonalInfo.rasi}
                                    </div>

                                    <div className="col-5 qus" style={style.qus}>
                                        லக்னம் <span className="float-end">:</span>
                                    </div>
                                    <div className="col-7 p-0" style={style.ans}>
                                        {PersonalInfo.laknam}
                                    </div>
                                </div>
                            </div>
                            <div className="col-5">
                                {showPhoto && (
                                    <div className="row">
                                        <div className="col-12 p-1">
                                            <div
                                                className="text-center"
                                                style={{ height: "370px", width: "90%" }}
                                            >
                                                <img
                                                    id="profile_img"
                                                    src={`https://kovaikongunadumatrimony.com/kkm_backend/public/api/proxy-image/${PersonalInfo.profile_photo_1}`}
                                                    alt="Profile"
                                                    className="img-fluid"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                        <div className="row ">
                            <div className="col-12">
                                <div className="text-center my-1">
                                    <span className="my-3 p-0 text-danger fw-bold">
                                        குடும்ப விவரம்
                                    </span>
                                </div>
                                <div>
                                    <div className="row mt-3">
                                        <div className="col-6">
                                            <div className="row">
                                                <div className="col-6 qus" style={style.qus}>
                                                    தந்தை பெயர் <span className="float-end">:</span>
                                                </div>
                                                <div className="col-6 p-0" style={style.ans}>
                                                    {PersonalInfo.father_name}
                                                </div>

                                                <div className="col-6 qus" style={style.qus}>
                                                    தந்தை பணி விபரம் <span className="float-end">:</span>
                                                </div>
                                                <div className="col-6 p-0" style={style.ans}>
                                                    {PersonalInfo.father_job_description}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-6">
                                            <div className="row">
                                                <div className="col-6 qus" style={style.qus}>
                                                    தாய் பெயர் <span className="float-end">:</span>
                                                </div>
                                                <div className="col-6 p-0" style={style.ans}>
                                                    {PersonalInfo.mother_name}
                                                </div>
                                                <div className="col-6 qus" style={style.qus}>
                                                    தாய் பணி விபரம் <span className="float-end">:</span>
                                                </div>
                                                <div className="col-6 p-0" style={style.ans}>
                                                    {PersonalInfo.mother_job_description}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-3 qus" style={style.qus}>
                                            உடன் பிறந்தவர்கள் <span className="float-end">:</span>
                                        </div>
                                        <div className="col-9 p-0" style={style.ans}>
                                            {PersonalInfo.siblings}
                                        </div>

                                        <div className="col-3 qus" style={style.qus}>
                                            சொத்து விபரம் <span className="float-end">:</span>
                                        </div>
                                        <div className="col-9 p-0" style={style.ans}>
                                            {PersonalInfo.property_details}
                                        </div>
                                        <div className="col-3 qus" style={style.qus}>
                                            எதிர்பார்ப்பு <span className="float-end">:</span>
                                        </div>
                                        <div className="col-9 p-0" style={style.ans}>
                                            {PersonalInfo.expectation}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <hr />
                            <div className="row">

                                <div className="col-6">
                                    <table
                                        className="birth-table"
                                        cellSpacing="2"
                                        cellPadding="2"
                                    >
                                        <tbody>
                                            <tr>
                                                <td
                                                    className={`rasi-birth fw-bold text-center ${RasiChart.r12}`}
                                                >
                                                    {RasiChartAlignment(RasiChart.r12)}
                                                </td>
                                                <td
                                                    className={`rasi-birth fw-bold text-center ${RasiChart.r1}`}
                                                >
                                                    {RasiChartAlignment(RasiChart.r1)}
                                                </td>
                                                <td
                                                    className={`rasi-birth fw-bold text-center ${RasiChart.r2}`}
                                                >
                                                    {RasiChartAlignment(RasiChart.r2)}
                                                </td>
                                                <td
                                                    className={`rasi-birth fw-bold text-center ${RasiChart.r3}`}
                                                >
                                                    {RasiChartAlignment(RasiChart.r3)}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td
                                                    className={`rasi-birth fw-bold text-center ${RasiChart.r11}`}
                                                >
                                                    {RasiChartAlignment(RasiChart.r11)}
                                                </td>
                                                <td
                                                    className="rasi-birth fw-bold chart-birth"
                                                    width="220"
                                                    height="220"
                                                    colSpan="2"
                                                    rowSpan="2"
                                                >
                                                    <p className="rasi-chart"> ராசி </p>
                                                </td>
                                                <td
                                                    className={`rasi-birth fw-bold text-center ${RasiChart.r4}`}
                                                >
                                                    {RasiChartAlignment(RasiChart.r4)}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td
                                                    className={`rasi-birth fw-bold text-center ${RasiChart.r10}`}
                                                >
                                                    {RasiChartAlignment(RasiChart.r10)}
                                                </td>
                                                <td
                                                    className={`rasi-birth fw-bold text-center ${RasiChart.r5}`}
                                                >
                                                    {RasiChartAlignment(RasiChart.r5)}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td
                                                    className={`rasi-birth fw-bold text-center ${RasiChart.r9}`}
                                                >
                                                    {RasiChartAlignment(RasiChart.r9)}
                                                </td>
                                                <td
                                                    className={`rasi-birth fw-bold text-center ${RasiChart.r8}`}
                                                >
                                                    {RasiChartAlignment(RasiChart.r8)}
                                                </td>
                                                <td
                                                    className={`rasi-birth fw-bold text-center ${RasiChart.r7}`}
                                                >
                                                    {RasiChart.r7}
                                                </td>
                                                <td
                                                    className={`rasi-birth fw-bold text-center ${RasiChart.r6}`}
                                                >
                                                    {RasiChartAlignment(RasiChart.r6)}
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div className="col-6">
                                    <table
                                        className="birth-table"
                                        cellSpacing="2"
                                        cellPadding="2"
                                    >
                                        <tbody>
                                            <tr>
                                                <td
                                                    className={`rasi-birth fw-bold text-center ${AmsamChart.a12}`}
                                                >
                                                    {AmsamChartAlignment(AmsamChart.a12)}
                                                </td>
                                                <td
                                                    className={`rasi-birth fw-bold text-center ${AmsamChart.a1}`}
                                                >
                                                    {AmsamChartAlignment(AmsamChart.a1)}
                                                </td>
                                                <td
                                                    className={`rasi-birth fw-bold text-center ${AmsamChart.a2}`}
                                                >
                                                    {AmsamChartAlignment(AmsamChart.a2)}
                                                </td>
                                                <td
                                                    className={`rasi-birth fw-bold text-center ${AmsamChart.a3}`}
                                                >
                                                    {AmsamChartAlignment(AmsamChart.a3)}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td
                                                    className={`rasi-birth fw-bold text-center ${AmsamChart.a11}`}
                                                >
                                                    {AmsamChartAlignment(AmsamChart.a11)}
                                                </td>
                                                <td
                                                    className="rasi-birth fw-bold chart-birth"
                                                    width="220"
                                                    height="220"
                                                    colSpan="2"
                                                    rowSpan="2"
                                                >
                                                    <p className="rasi-chart text-center"> நவாம்சம் </p>
                                                </td>
                                                <td
                                                    className={`rasi-birth fw-bold text-center ${AmsamChart.a4}`}
                                                >
                                                    {AmsamChartAlignment(AmsamChart.a4)}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td
                                                    className={`rasi-birth fw-bold text-center ${AmsamChart.a10}`}
                                                >
                                                    {AmsamChartAlignment(AmsamChart.a10)}
                                                </td>
                                                <td
                                                    className={`rasi-birth fw-bold text-center ${AmsamChart.a5}`}
                                                >
                                                    {AmsamChartAlignment(AmsamChart.a5)}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td
                                                    className={`rasi-birth fw-bold text-center ${AmsamChart.a9}`}
                                                >
                                                    {AmsamChartAlignment(AmsamChart.a9)}
                                                </td>
                                                <td
                                                    className={`rasi-birth fw-bold text-center ${AmsamChart.a8}`}
                                                >
                                                    {AmsamChartAlignment(AmsamChart.a8)}
                                                </td>
                                                <td
                                                    className={`rasi-birth fw-bold text-center ${AmsamChart.a7}`}
                                                >
                                                    {AmsamChartAlignment(AmsamChart.a7)}
                                                </td>
                                                <td
                                                    className={`rasi-birth fw-bold text-center ${AmsamChart.a6}`}
                                                >
                                                    {AmsamChartAlignment(AmsamChart.a6)}
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            {PersonalInfo.dhisaiiruppu_planet && (
                                <div className="col-12 fw-bold mb-0 mt-1" style={style.ans}>
                                    <p className="mb-0">
                                        {" "}
                                        {PersonalInfo.dhisaiiruppu_planet} திசை இருப்பு{" "}
                                        {PersonalInfo.thasa_year} வருடம் {PersonalInfo.thasa_month}{" "}
                                        மாதம் {PersonalInfo.thasa_day} நாட்கள்
                                        <span className="float-end">:</span>
                                    </p>
                                </div>
                            )}
                        </div>
                    </div>
                </section>
            </div>
        </>
    );
}

const DownloadPdfSection = ({ Value }) => {
    const componentRef = React.useRef();
    const [showPhoto, setShowPhoto] = useState(true);
    const [isDownloading, setIsDownloading] = useState(false);

    useEffect(() => {
        if (isDownloading) {
            const images = componentRef.current.querySelectorAll("img");
            const imagePromises = Array.from(images).map(
                (img) =>
                    new Promise((resolve) => {
                        if (img.complete) {
                            resolve();
                        } else {
                            img.onload = resolve;
                            img.onerror = resolve;
                        }
                    })
            );

            Promise.all(imagePromises).then(() => {
                html2pdf()
                    .from(componentRef.current)
                    .set({
                        margin: 0,
                        filename: "biodata.pdf",
                        image: { type: "jpeg", quality: 1 },
                        html2canvas: {
                            scale: 2,
                            useCORS: true,
                            allowTaint: false
                        },
                        jsPDF: { unit: "in", format: "a4", orientation: "portrait" },
                    })
                    .save()
                    .then(() => {
                        setIsDownloading(false);
                        setShowPhoto(true);
                    });
            });
        }
    }, [isDownloading]);

    const handleDownload = (withPhoto) => {
        setShowPhoto(withPhoto);
        setIsDownloading(true);
    };

    return (
        <div>
            <div className="">
                <div ref={componentRef}>
                    <PdfBiodata Value={Value} showPhoto={showPhoto} />
                </div>
                <div className="d-flex justify-content-center mb-3">
                    <button className="download-btn me-2" onClick={() => handleDownload(true)}>
                        Download PDF
                    </button>
                    <button className="download-btn" onClick={() => handleDownload(false)}>
                        Download without Photo
                    </button>
                </div>
            </div>
        </div>
    );
};

export default function AdminDownloadpdf() {
    const [Value, setValue] = useState("");
    const { id } = useParams();

    useEffect(() => {
        const data = {
            profile_id: id,
        };
        axios
            .post(
                "https://kovaikongunadumatrimony.com/kkm_backend/public/api/admin-bio-data",
                data
            )
            .then((response) => {
                if (response.data.status == true) {
                    // console.log("res", response.data);
                    setValue(response.data);
                } else {
                    Notify.failure(response.data.message);
                }
            });
    }, []);

    return (
        <>
            <DownloadPdfSection Value={Value}></DownloadPdfSection>
        </>
    );
}
